<template>
    <div class="animated fadeIn">
        <Request
                ref="requestProductView"
                :onRequestSuccess="onRequestProductViewSuccess"
                root="/shop/product-view">
            <slot slot="body">
                <b-row class="mb-4 mt-2">
                    <b-col class="text-right">
                        <b-button-group>
                            <b-button @click="onCartClick" class="btn btn-light"> <b-badge class="animated fadeIn badge-success ml-1" v-if="cartCount !== false">{{cartCount}}</b-badge><i class="fa fa-shopping-cart mr-1 ml-2"></i> {{Core.Definition.getDefinition('Mon panier')}}</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
                <b-row v-if="Core.Validation.isId(dataProduct.id) && (dataProduct.status === Core.Product.statusPublish||dataProduct.status === Core.Product.statusHidden)" >
                    <b-col>
                        <b-card>
                            <ProductView @onAddToCartClick="onAddToCartClick" @onPurchaseClick="onPurchaseClick" v-if="Core.Validation.isId(dataProduct.id)" v-model="dataProduct"></ProductView>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row v-if="Core.Validation.isId(dataProduct.id) && dataProduct.status !== Core.Product.statusPublish&&dataProduct.status !== Core.Product.statusHidden">
                    <b-col>
                        <b-card>
                            <b-alert show variant="alert">
                                {{Core.Definition.getDefinition('Le produit n\'est plus disponible.')}}
                            </b-alert>
                        </b-card>
                    </b-col>
                </b-row>
            </slot>
        </Request>
    </div>
</template>

<script>
    import ProductView from '../../../components/ProductView'
    import Request from '../../../components/Request'
    export default {
        name: 'ShopProductView',
        components: {
            ProductView,
            Request
        },
        props: {
            productsRedirectType: {
                type: String,
                default: 'router'
            },
            productsRedirectUrl: {
                type: String,
                default: ''
            },
            cartRedirectType: {
                type: String,
                default: 'router'
            },
            cartRedirectUrl: {
                type: String,
                default: ''
            }
        },
        computed: {
            cartCount() {
                let count = 0
                let products = Core.Session.Cart.products
                for(let product in products) {
                    product = products[product]
                    if ( product.quantity !== undefined) {
                        count += parseInt(product.quantity)
                    }
                }
                return count
            }
        },
        mounted() {
            let id = this.$route.params.id
            if (Core.Validation.isId(id)) {
                this.request(id)
            }
        },
        data: function () {
            return {
                Core: window.Core,
                dataProduct: {

                }
            }
        },
        methods: {
            onRequestProductViewSuccess(data) {
                if (data.product!==undefined) {
                    this.dataProduct = data.product
                }
            },
            request(id) {
                this.$refs.requestProductView.clearArgs()
                this.$refs.requestProductView.addArg('id', id)
                this.$refs.requestProductView.request()
            },
            onCartClick(selectedProduct, product) {

                if (product !== undefined && !Core.Session.Cart.hasProduct(product.id)) {
                    product.quantity = 1
                    this.onAddToCartClick(product)
                }

                let cartRedirectUrl = ''
                if (this.cartRedirectUrl !== '') {
                    cartRedirectUrl = this.cartRedirectUrl
                }

                switch(this.cartRedirectType) {
                    case 'router':
                        if (cartRedirectUrl==='') {
                            cartRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/panier')
                        }
                        this.$router.push(cartRedirectUrl)
                        break
                    case 'url':
                        if (cartRedirectUrl!=='') {
                            window.open(cartRedirectUrl, '_self');
                        }
                        break
                }
            },
            onAddToCartClick(product) {
                Core.Session.Cart.add2(product)
            },
            onPurchaseClick(product) {
                this.onAddToCartClick(product)
                this.onCartClick()
            }
        }
    }
</script>
